import React, { useEffect, useState } from 'react'
// components
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material'
import AdxDrawerComponent from 'components/reusable/drawer/AdxDrawerComponent'
import AttendanceStepper from './AttendanceStepper'

// services
import { calculateTimeDifferenceFormatted, formatTimeToAmPm } from 'services/helper/DateTime'

// icons
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined'
import AttendanceLabelRenderer from 'components/custom/AdxLabelRenderer'

const DashboardDetailsDrawer = ({ data, drawerState, setDrawerState }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const handleDrawer = (anchor, open) => (event) => {
    setDrawerState({ ...drawerState, [anchor]: open })
  }
  const [steps, setSteps] = useState([])
  const [showMap, setShowMap] = useState({})
  const activeStep = 1

  const toggleMap = (stepIndex) => {
    setShowMap(prev => ({
      ...prev,
      [stepIndex]: !prev[stepIndex]
    }))
  }

  const clockIn = data?.attendance?.clockin?.clockin
  const clockOut = data?.attendance?.clockout?.clockout
  const duration = calculateTimeDifferenceFormatted(clockIn, clockOut)


  useEffect(() => {
    const stepsArray = []

    if (data?.attendance?.clockin) {
      const formattedTime = formatTimeToAmPm(clockIn)
      stepsArray.push({
        label: `${formattedTime} • Clock in`,
        description: data?.attendance?.clockin?.street,
        note: data?.attendance?.clockin?.remarks,
        coordinates: {
          latitude: data?.attendance?.clockin?.latitude || '3.139000', // Fallback for testing
          longitude: data?.attendance?.clockin?.longitude || '101.686900' // Fallback for testing
        },
        hasMap: true // Always show map for testing
      })
    }

    if (data?.attendance?.clockout) {
      const formattedTime = formatTimeToAmPm(clockOut)
      stepsArray.push({
        label: `${formattedTime} • Clock out`,
        description: data?.attendance?.clockout?.street,
        note: data?.attendance?.clockout?.remarks,
        coordinates: {
          latitude: data?.attendance?.clockout?.latitude || '3.139000', // Fallback for testing
          longitude: data?.attendance?.clockout?.longitude || '101.686900' // Fallback for testing
        },
        hasMap: true // Always show map for testing
      })
    }

    setSteps(stepsArray)
  }, [clockIn, clockOut, data])

  return (
    <>
      <AdxDrawerComponent
        state={drawerState}
        anchor="right"
        onClose={handleDrawer}
        headerprops
        title={data?.date}
        sx={{
          width: isMobile ? '100vw' : '450px',
        }}
      >
        <Box
          sx={{
            padding: '16px',
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            border: 1,
            borderColor: 'gray-line.main',
            borderRadius: '4.5px',
            marginBottom: '32px',
          }}
        >
          <Box
            sx={{
              background: 'linear-gradient(to right, #EF6617, #F3BF3A, #F27C19)',
              color: 'white.main',
              padding: '12px 16px',
              borderRadius: '4.5px',
            }}
          >
            <Typography>
              {data?.attendance?.clockin?.mode_id === 1
                ? 'Work from office'
                : data?.attendance?.clockin?.mode_id === 2
                ? 'Working remotely'
                : '--'}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                borderRight: 1,
                borderColor: 'gray-line.main',
                paddingRight: '18%',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: 'default-background.main',
                  borderRadius: '100%',
                  border: 1,
                  borderColor: 'gray-line.main',
                  width: '50px',
                  height: '50px',
                }}
              >
                <TimerOutlinedIcon sx={{ color: 'alternate.main', fontSize: '28px' }} />
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                <Typography sx={{ color: 'light-gray-text.main' }}>Total clocked</Typography>
                <Typography sx={{ fontWeight: clockIn && clockOut ? 'bold' : 'normal' }}>
                  {clockIn && clockOut ? `${duration} hrs` : '--:--'}
                </Typography>
              </Box>
            </Box>
            {/* <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '6px 10px',
                borderRadius: '45px',
                backgroundColor: 'default-background.main',
              }}
            >
              <Typography>{statusLabels[data?.attendance?.status] || '--'}</Typography>
            </Box> */}
            <Box
              sx={{
                width: 'fit-content',
                maxWidth: '200px',
              }}
            >
              <AttendanceLabelRenderer
                status={data?.attendance?.status}
                withText
                withChip
                isHoliday={data?.is_holiday}
              />
            </Box>
          </Box>
        </Box>
        <Box>
          <AttendanceStepper 
            steps={steps} 
            activeStep={activeStep} 
            loading={false}
            showMap={showMap}
            toggleMap={toggleMap}
          />
        </Box>
      </AdxDrawerComponent>
    </>
  )
}

export default DashboardDetailsDrawer
